import Barn from '@/components/icons/customizations/Barn';
import { Buck } from '@/components/icons/customizations/Buck';
import Building from '@/components/icons/customizations/Building';
import CenterPivot from '@/components/icons/customizations/CenterPivot';
import Circle from '@/components/icons/customizations/Circle';
import CrossHairs from '@/components/icons/customizations/CrossHairs';
import DrawCircle from '@/components/icons/customizations/DrawCircle';
import Fence from '@/components/icons/customizations/Fence';
import Grate from '@/components/icons/customizations/Grate';
import HouseChimney from '@/components/icons/customizations/House';
import Mark from '@/components/icons/customizations/Mark';
import MergeShapes from '@/components/icons/customizations/MergeShapes';
import Oil from '@/components/icons/customizations/Oil';
import Path from '@/components/icons/customizations/Path';
import Pin from '@/components/icons/customizations/Pin';
import Pipeline from '@/components/icons/customizations/Pipeline';
import Pivot from '@/components/icons/customizations/Pivot';
import { Pump } from '@/components/icons/customizations/Pump';
import Road from '@/components/icons/customizations/Road';
import Solar from '@/components/icons/customizations/Solar';
import Split from '@/components/icons/customizations/Split';
import Square from '@/components/icons/customizations/Square';
import Squares from '@/components/icons/customizations/Squares';
import Star from '@/components/icons/customizations/Star';
import Storage from '@/components/icons/customizations/Storage';
import Text from '@/components/icons/customizations/Text';
import Tracks from '@/components/icons/customizations/Tracks';
import Well from '@/components/icons/customizations/Well';
import Wind from '@/components/icons/customizations/Wind';

export {
  Barn,
  Buck,
  Building,
  CenterPivot,
  Circle,
  CrossHairs,
  DrawCircle,
  Fence,
  Grate,
  HouseChimney,
  Mark,
  MergeShapes,
  Oil,
  Path,
  Pin,
  Pipeline,
  Pivot,
  Pump,
  Road,
  Solar,
  Split,
  Square,
  Squares,
  Star,
  Storage,
  Text,
  Tracks,
  Well,
  Wind,
};
